const menuUnselectedColor = '#696F88';
const menuSelectedColor = '#59B948';
const expandButtonColor = '#14151C';

export {
    menuUnselectedColor,
    menuSelectedColor,
    expandButtonColor
};